module.exports = __webpack_public_path__ + "media/common/images/badges/gray/matador-54929e4c43fde3192018bef014390858.svg";